"use client";
import React, { useEffect, useState } from "react";
import { Input, Select, Pagination, Spin, Empty } from "antd";
import { IoSearchOutline } from "react-icons/io5";
import { ArrowLeft, ArrowRight } from "lucide-react";
import SectionTitle from "@/components/common/section-title/SectionTitle";
import BranchCard from "./components/BranchCard";
import CommonService from "@/services/api/CommonService";

const { Option } = Select;

export default function BranchesPage() {
  const [branches, setBranches] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");
  const [districtId, setDistrictId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const fetchBranches = async (page = 1) => {
    setLoading(true);
    try {
      const response = await CommonService.getAllBranch({
        page,
        per_page: pageSize,
        search,
        district_id: districtId,
      });

      if (response) {
        setBranches(response.data || []);
        setTotalItems(response.total || 0);
        setCurrentPage(response.current_page || page);
        setPageSize(response.per_page || pageSize);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDistricts = async () => {
    try {
      const response = await CommonService.getAllDistricts();
      if (response) {
        setDistricts(response);
      }
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  };

  useEffect(() => {
    fetchDistricts();
    fetchBranches(1);
  }, []);

  useEffect(() => {
    fetchBranches(currentPage);
  }, [currentPage]);

  const handleSearch = () => {
    setCurrentPage(1);
    fetchBranches(1);
  };

  return (
    <section className="branches_section section_padding-48">
      <div className="container">
        <SectionTitle
          iconSrc={"/images/home-page/location-title-icon.avif"}
          title="দেশব্যাপি ফোকাস একাডেমিকের পরীক্ষা কেন্দ্র সমূহ"
          description={
            "ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের মাধ্যমে আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।"
          }
        />

        {/* Search area */}
        <div className="branch-search-area">
          <div className="search-content">
            <div className="branch-name">
              <Input
                placeholder="পরীক্ষা কেন্দ্র নাম দিয়ে খুঁজো"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="branch-location">
              <Select
                allowClear
                showSearch
                value={districtId}
                onChange={(value) => setDistrictId(value)}
                placeholder="লোকেশন বাছাই করে খুঁজো"
                style={{ width: "100%" }}
                optionFilterProp="children" 
              >
                {districts.map((district) => (
                  <Option key={district.id} value={district.id}>
                    {district.name}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="search">
              <button className="search_btn" onClick={handleSearch}>
                <IoSearchOutline />
              </button>
            </div>
          </div>
        </div>

        {/* Branch list */}
        <div className="branches-list">
          {/* {loading ? (
            <div className="text-center py-10">
              <Spin size="large" />
            </div>
          ) :
           */}
          {branches.length > 0 ? (
            branches

              .filter((branch) => branch.name && branch.phone)
              .map((branch, index) => (
                <BranchCard
                  key={index}
                  title={branch.name}
                  number1={branch.phone}
                  number2={branch.phone2}
                  number3={branch.address}
                  slug={branch.slug}
                />
              ))
          ) : (
            <div className="text-center py-10 text-gray-500">
              <Empty description="কোনো পরীক্ষা কেন্দ্র পাওয়া যায়নি।" />
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalItems > pageSize && (
          <div className="fa-pagination">
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={totalItems}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
              itemRender={(page, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <a>
                      <ArrowLeft />
                    </a>
                  );
                }
                if (type === "next") {
                  return (
                    <a>
                      <ArrowRight />
                    </a>
                  );
                }
                return originalElement;
              }}
            />
          </div>
        )}
      </div>
    </section>
  );
}
